import { MyErrorZ } from "@/framework/errors/MyError";
import { z } from "zod";

// DeepL accepts at most 50 texts per request, which a later
// provider-level batching step can map onto one call.
export const MAX_TRANSLATION_BATCH_SIZE = 50;

export const TrackParagraphTranslationItemZ = z.object({
  kind: z.literal("trackParagraph"),
  trackId: z.string(),
  paragraphId: z.string(),
  targetLang: z.string(),
  startTime: z.number(),
  endTime: z.number(),
  text: z.string(),
  onlyIfExists: z.boolean().nullish(),
});

// Free text such as titles and descriptions.
// subject: `feed:123:title`, `track:...:description`, etc
export const TextTranslationItemZ = z.object({
  kind: z.literal("text"),
  subject: z.string(),
  text: z.string(),
  sourceLang: z.string(),
  targetLang: z.string(),
});

export const TranslationBatchItemZ = z.discriminatedUnion("kind", [
  TrackParagraphTranslationItemZ,
  TextTranslationItemZ,
]);

// Each item fails on its own, so one bad paragraph doesn't fail the batch.
export const TranslationBatchItemResultZ = z.union([
  z.object({ translation: z.string().nullable() }),
  z.object({ error: MyErrorZ }),
]);

export type TrackParagraphTranslationItem = z.infer<
  typeof TrackParagraphTranslationItemZ
>;
export type TextTranslationItem = z.infer<typeof TextTranslationItemZ>;
export type TranslationBatchItem = z.infer<typeof TranslationBatchItemZ>;
export type TranslationBatchItemResult = z.infer<
  typeof TranslationBatchItemResultZ
>;
